module.exports = __webpack_public_path__ + "img/settings_camera_icon.c89120cc.svg";